import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { CommonAuthService } from 'common/auth/common-auth.service';
import { bcStates } from 'common/common/states';

@Injectable({
  providedIn: 'root'
})
export class RootAuthGuard implements CanActivate {
  constructor(private readonly _commonAuthService: CommonAuthService, private readonly _router: Router) {}

  async canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const isSuccess = await this._commonAuthService.init(false, activatedRouteSnapshot);
    if (isSuccess && this._commonAuthService.isGenesysEnabled) {
      const hasPermission = await this._commonAuthService.hasDigitalDesktopPermission();
      if (!hasPermission) {
        return this._router.createUrlTree([bcStates.permissionDenied.url]);
      }
    }
    return isSuccess;
  }
}
